'use client';
import { LoveverySWRConfig } from '@/components/common/LoveverySWRConfig';
import { ChatbotWidget } from '@/components/common/ChatbotWidget';
import { AuthProvider } from '@/context/AuthContext';
import '@/styles/base.scss';
import '@/styles/globals.scss';
import { useNavigationEvent } from '@/hooks/useNavigationEvent';
import { FeatureProvider } from '@/context/FeatureProvider';
import { AppProgressBar as ProgressBar } from 'next-nprogress-bar';
import { usePathname } from 'next/navigation';
import { NextIntlClientProvider } from 'next-intl';
import { pageEvent } from '@/utils/rudderstack';
import { CartContextProvider } from '@/context/CartContext';
import { SubscriptionProvider } from '@/context/SubscriptionContext';
import { IS_DEV_ENV } from '../constants';

function shouldDisplayProgressBar(path?: string | null) {
  if (!path) return false;
  return path.includes('account');
}

export default function Providers({
  children,
  locale = 'en-US',
}: {
  children: React.ReactNode;
  locale: string;
}) {
  useNavigationEvent(pageEvent);
  const pathname = usePathname();

  return (
    <NextIntlClientProvider locale={locale}>
      <LoveverySWRConfig>
        <AuthProvider>
          <SubscriptionProvider>
            <FeatureProvider>
              <ChatbotWidget />
              {(shouldDisplayProgressBar(pathname) || IS_DEV_ENV) && (
                <ProgressBar
                  height="4px"
                  color="#536dc4"
                  options={{ easing: 'ease', speed: 500 }}
                  shallowRouting
                />
              )}
              <CartContextProvider>{children}</CartContextProvider>
            </FeatureProvider>
          </SubscriptionProvider>
        </AuthProvider>
      </LoveverySWRConfig>
    </NextIntlClientProvider>
  );
}
